/** Coming Soon when common league_status is pre_draft or drafting. Missing/other values => do not block. */
export const isDraftAdviceDisabledByLeagueStatus = (leagueStatus: unknown): boolean => {
  if (typeof leagueStatus !== "string" || !leagueStatus.trim()) return false;
  const normalized = leagueStatus.trim().toLowerCase().replace(/-/g, "_");
  return normalized === "pre_draft" || normalized === "drafting";
};

/** Case-insensitive match against platform ids from runtime env (MFL, Sleeper, ESPN, Yahoo, Flea_flicker). */
export const isDraftAdviceDisabledForPlatform = (platformId: string | undefined, disabledPlatforms: string[] | undefined | null): boolean => {
  if (!platformId || !disabledPlatforms?.length) return false;
  const normalized = platformId.trim().toLowerCase();
  return disabledPlatforms.some((p) => p.trim().toLowerCase() === normalized);
};
